const linkNavigator = (link, navigate) => {
    if (!link) {
        return;
    }
    console.log('link:', link);
    switch (link.type) {
        case 'url':
            if (link?.url?.toLowerCase().startsWith('http') && window) {
                window.location = link.url;
                return;
            }
            navigate(link.url);
            break;
        case 'social':
            navigate(link.url);
            break;
        case 'home':
            navigate('home');
            break;
        case 'category':
            navigate(`cat/${link.slug || link.category}`);
            break;
        case 'course':
            navigate(`course/${link.slug || link.course}`);
            break;
        case 'document':
            navigate(`document/${link.slug || link.document}`);
            break;
        case 'program':
            navigate(`program/${link.slug || link.program}`);
            break;
        case 'meeting':
            navigate(`meeting/${link.meeting}`);
            break;
        case 'microcast':
            navigate(`microcast/${link.slug || link.microcast}`);
            break;
        case 'checkout':
            // @TODO - this duplicates logic from Membership.checkoutUrl - refactor it out somehow
            navigate(`checkout?type=membership&id=${link.membership}`);
            break;
        case 'none':
            break;
        default:
            console.log('Type not supported', link.type);
    }
};
export default linkNavigator;
//# sourceMappingURL=linkNavigator.js.map